import React from "react";

export default class ChevronDownSVG_16x16 extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 7L8 11L12 7" />
      </svg>
    );
  }
}
